import { apiWrapper } from './helpers';

// region Get Saved Proposals
export function getSavedProposals(truckID) {
    return apiWrapper(
        `/vendor/v2/proposal/${truckID}/template`,
        'GET',
        'GET SAVED PROPOSALS'
    );
}
// endregion

// region Save New Proposal
export function saveNewProposal(truckID, proposalData = {}) {
    return apiWrapper(
        `/vendor/v2/proposal/${truckID}/template`,
        'POST',
        'CREATED NEW SAVED PROPOSAL',
        JSON.stringify(proposalData),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region Update Saved Proposal
export function updateSavedProposal(truckID, templateID = null, proposalData = {}) {
    return apiWrapper(
        `/vendor/v2/proposal/${truckID}/template/${templateID}`,
        'PATCH',
        'UPDATE SAVED PROPOSAL',
        JSON.stringify(proposalData),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region Delete Saved Proposal
export function deleteSavedProposal(truckID, templateID = null) {
    return apiWrapper(
        `/vendor/v2/proposal/${truckID}/template/${templateID}`,
        'DELETE',
        'DELETE SAVED PROPOSAL'
    );
}
// endregion

// region Log Sent Proposal to Braze
export function logSentProposal(truckID, templateID = null) {
    return apiWrapper(
        `/vendor/v2/proposal/${truckID}/template/${templateID}/send`,
        'POST',
        'LOG SENT PROPOSAL TO BRAZE'
    );
}
// endregion
